export function minutesToHHMM(m) {
  const hh = Math.floor(m / 60);
  const mm = Math.floor(m % 60);
  return `${String(hh).padStart(2, "0")}:${String(mm).padStart(2, "0")}`;
}

export function hhmmToMinutes(s) {
  const txt = String(s || "").trim();
  const m = txt.match(/^(\d{1,2}):(\d{2})$/);
  if (!m) return 0;
  const hh = parseInt(m[1], 10);
  const mm = parseInt(m[2], 10);
  return hh * 60 + mm;
}

export function snapMinutes(v, step) {
  return Math.round(v / step) * step;
}
